import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-popup-dialog',
  templateUrl: './popup-dialog.component.html',
  styleUrls: ['./popup-dialog.component.scss'],
})
export class PopupDialogComponent implements OnInit {
  public static result = false;
  title: string = '';

  constructor(
    public dialogRef: MatDialogRef<PopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
  ) {
    this.dialogData = JSON.stringify(this.dialogData);
    this.dialogData = JSON.parse(this.dialogData);
    this.title = this.dialogData.title;
  }

  ngOnInit(): void { }

  onYes(): void {
    PopupDialogComponent.result = true;
    this.onClose();
  }

  onNo(): void {
    PopupDialogComponent.result = false;
    this.onClose();
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
